export const Spacer = ({ size = 20 }) => {
    return (
        <div className="spacer" style={{ height: size }}></div>
    )
}